import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./productListing.gql";
import { useSelector } from "react-redux";

export const useProductListing = (props = {}) => {
  const { getProductListingQuery } = DEFAULT_OPERATIONS;
  const { cartId } = useSelector((state) => state.cartSlice);

  const [fetchProductListing, { called, data, error, loading }] = useLazyQuery(
    getProductListingQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
    }
  );

  useEffect(() => {
    if (cartId) {
      fetchProductListing({
        variables: {
          cartId,
        },
      });
    }
  }, [cartId, fetchProductListing]);

  let items = [];
  if (called && !error && !loading) {
    items = data.cart.items;
  }

  return {
    isLoading: !!loading,
    items,
  };
};
